module.exports = __webpack_public_path__ + "img/chat-pin-active.4e5c0d41.svg";